exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/emailtemplates/emailtemplates.component.css
// module id = ../../../../../src/app/emailtemplates/emailtemplates.component.css
// module chunks = main